import { toast } from "react-toastify";
import api from "src/utils/api";
import { HOST_PROFILE_TYPES } from "./types";
import axios from "axios";
import { APIURL } from "src/utils/misc";

export const editHost = (data) => {
  return async () => {
    try {
      let dataPayload = {
        ...data.host.User_ID,
        address: data.address,
        first_name: data.first_name,
        last_name: data.last_name,
        phone_number: data.phone_number,
        username: data.username,
        about: data.about,
        country: data.country,
      };

      const res = await api.patch(`users/update/me`, dataPayload);
      localStorage.setItem("USERNAME", res.data.username);
      localStorage.setItem("IMAGE", res.data.photo);
      toast.success("Profile updated successfully");
      setTimeout(() => {
        window.location.replace("/app/dashboard");
      }, 2000);
    } catch (error) {
      toast.error("Error updating profile, please try again");
    }
  };
};

export const updatePaymentDetails = (data) => async (dispatch) => {
  try {
    const res = await api.patch(`hosts/update/me`, data);
    dispatch({
      type: HOST_PROFILE_TYPES.HOST_PROFILE_FETCH_SUCCESS,
      payload: res.data.data,
    });
    window.location.replace("/app/dashboard");
  } catch (error) {
    toast.error("Error updating profile, please try again");
  }
};

export const uploadProfilePhoto = async (formData) => {
  try {
    const url = `${APIURL}users/update/photo`;
    const ACCESS_TOKEN = localStorage.getItem("HOST_TOKEN");
    const res = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${ACCESS_TOKEN}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data.path;
  } catch (error) {
    toast.error("Sorry, photo was unable to update please try again");
  }
};

export const onAddSubHost = (userId) => async () => {
  try {
    const host = localStorage.getItem("HOST_ID");
    const res = await api.patch(`hosts/${host}/link/${userId}`);
    if (res.data.status === "fail") {
      toast.error(res.data.message);
    } else {
      toast.success(res.data.message);
      window.location.reload();
    }
  } catch (error) {
    toast.error("Error adding subhost, please try again");
  }
};

export const onRemoveSubHost = (userId) => async () => {
  try {
    const host = localStorage.getItem("HOST_ID");
    const res = await api.patch(`hosts/unlink/${userId}?host=${host}`);
    if (res.data.status === "fail") {
      toast.error(res.data.message);
    } else {
      toast.success(res.data.message);
      window.location.reload();
    }
  } catch (error) {
    toast.error("Error adding subhost, please try again");
  }
};

export const fetctHostProfile = () => {
  return async (dispatch) => {
    try {
      const res = await api.get(`hosts/me`);
      dispatch({
        type: HOST_PROFILE_TYPES.HOST_PROFILE_FETCH_SUCCESS,
        payload: res.data.data,
      });
    } catch (error) {
      dispatch({
        type: HOST_PROFILE_TYPES.HOST_PROFILE_ERROR,
        payload: "We're working on it, please try again while we implement..",
      });
    }
  };
};

// const homeReservationsSuccess = (payload) => ({
//   type: HOST_PROFILE_TYPES.HOST_RESERVATIONS_SUCCESS,
//   payload,
// });

export const homeReservationAsync = () => async (dispatch) => {
  try {
    // const res = await api.get(`reservations/host/${host}`);
    // dispatch(homeReservationsSuccess(res.data.reservations));
  } catch (error) {}
};

export const updateReservationAsync = (data, reservationId) => async () => {
  try {
    await api.patch(`reservations/${reservationId}`, data);
    toast.success(`Reservation has been ${data.status} successfully.`);
    window.location.reload();
  } catch (error) {
    toast.error(`Kindly check your connection and try again.`);
  }
};
